import React, { useState, FC } from "react";

interface ReadMoreProps {
  text?: string | null; // explicitly handle possible null
  maxLength?: number;
  className?: string;
}

const ReadMore: FC<ReadMoreProps> = ({
  text,
  maxLength = 100,
  className = "",
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const safeText = typeof text === "string" ? text : "";
  const shouldTruncate = safeText.length > maxLength;
  const displayedText =
    shouldTruncate && !isExpanded
      ? safeText.slice(0, maxLength) + "..."
      : safeText;

  const toggleReadMore = () => setIsExpanded((prev) => !prev);

  return (
    <span className={className}>
      {displayedText}
      {shouldTruncate && (
        <span
          onClick={toggleReadMore}
          className="btn btn-secondary cursor-pointer ms-2"
          style={{ fontWeight: 500 }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </span>
      )}
    </span>
  );
};

export default ReadMore;
